import {HandPosition} from "./HandPosition";

export class BlackjackBet {
    constructor(public betAmount: number, private handPosition: HandPosition) {
    }

    public getBetAmount(): number {
        return this.betAmount;
    }

    public getHandPosition(): HandPosition {
        return this.handPosition;
    }
}



// WEBPACK FOOTER //
// ./src/app/BlackjackBet.ts